import { useSelector } from "react-redux";
import { RootState } from "../reducers";

export const useAnalysis = () => {
  const analysis = useSelector((state: RootState) => state.terms.analysis);
  return {
    analysis
  }
}   